/**
 * Zet de platte tekst van een AI-antwoordvoorstel om naar de HTML die de
 * e-maileditors (Quill) verwachten.
 *
 * Alinea's zijn gescheiden door een lege regel — zo vraagt de prompt het — en losse
 * regeleindes horen binnen dezelfde alinea, want de afsluiting ("Met vriendelijke
 * groeten," + de naam) hoort bij elkaar. Zonder deze omzetting komt het voorstel als
 * één blok in de editor.
 */
export function replySuggestionToHtml(body: string): string {
  return body
    .split(/\n{2,}/)
    .map((alinea) => `<p>${alinea.replace(/\n/g, '<br>')}</p>`)
    .join('');
}
